<fb-page-header [title]="'USERS' | translate" [subtitle]="'USERS_SUBTITLE' | translate">
    <a actions pButton severity="success" [routerLink]="['/organizations', orgId(), 'admin', 'users', 'new']">
        <i class="ph ph-user-plus"></i>
        <span>{{ 'INVITE_USER' | translate }}</span>
    </a>
</fb-page-header>

<section class="rounded-md bg-surface border border-border overflow-hidden">
    <div class="flex items-center justify-between gap-3 p-4 border-b border-border">
        <p-iconfield class="w-full max-w-sm">
            <p-inputicon class="ph ph-magnifying-glass" />
            <input
                pInputText
                type="search"
                class="w-full"
                [placeholder]="'SEARCH_USERS' | translate"
                [ngModel]="search()"
                (ngModelChange)="search.set($event)" />
        </p-iconfield>
        <span class="text-sm text-text-muted whitespace-nowrap">{{ rows().length }} {{ 'USERS' | translate | lowercase }}</span>
    </div>

    <p-table [value]="rows()" [loading]="loading()" [rowHover]="true" dataKey="_id">
        <ng-template #header>
            <tr>
                <th>{{ 'NAME' | translate }}</th>
                <th>{{ 'ROLE' | translate }}</th>
                <th>{{ 'VENUES' | translate }}</th>
                <th>{{ 'LAST_LOGIN' | translate }}</th>
                <th>{{ 'STATUS' | translate }}</th>
                <th class="w-10"></th>
            </tr>
        </ng-template>
        <ng-template #body let-user>
            <tr class="cursor-pointer" (click)="open(user)">
                <td>
                    <div class="flex items-center gap-3">
                        <span
                            class="size-9 shrink-0 rounded-full flex items-center justify-center bg-concern-accent text-concern-accent-title text-sm font-semibold">
                            {{ user.initials }}
                        </span>
                        <div class="flex flex-col min-w-0">
                            <span class="font-medium text-text truncate">{{ user.name }}</span>
                            <span class="text-xs text-text-muted truncate">{{ user.email }}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <p-tag
                        [value]="user.roleKey | translate"
                        [severity]="user.roleKey === 'ROLE_OWNER' ? 'contrast' : user.roleKey === 'ROLE_NONE' ? 'warn' : 'secondary'" />
                </td>
                <td class="text-sm text-text-2">
                    @if (venueLabel(user); as label) {
                        {{ label | translate }}
                    } @else {
                        {{ user.associatedClients.length }} / {{ venueCount() }}
                    }
                </td>
                <td class="text-sm text-text-2">
                    @if (user.lastLoggedIn) {
                        {{ user.lastLoggedIn | date: 'mediumDate' }}
                    } @else {
                        <span class="text-text-muted">{{ 'NEVER' | translate }}</span>
                    }
                </td>
                <td>
                    <p-tag
                        [value]="(user.disabled ? 'DISABLED' : 'ACTIVE') | translate"
                        [severity]="user.disabled ? 'danger' : 'success'" />
                </td>
                <td class="text-text-muted"><i class="ph ph-caret-right"></i></td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="6">
                    <fb-empty-state
                        icon="ph-users"
                        [title]="(search() ? 'NO_USERS_MATCH' : 'NO_USERS_YET') | translate"
                        [text]="(search() ? 'NO_USERS_MATCH_TEXT' : 'NO_USERS_YET_TEXT') | translate" />
                </td>
            </tr>
        </ng-template>
    </p-table>
</section>
